<template>
    <div>
        <div class="whitebox right_topbox">
            <div class="right_boxtitle map_title_tab second_tab">
                <span class="title" @click="selectedPrimaryElectionId(1)"
                    :class="primaryElectionId == 1 ? 'current' : ''">目标企业初选</span>
                <span class="title" @click="selectedPrimaryElectionId(2)"
                    :class="primaryElectionId == 2 ? 'current' : ''">算法精准匹配</span>

            </div>
            <div v-show="primaryElectionId == 2">
                <dl class="opport-screen bdbe">
                    <dt class="fl">企业实力</dt>
                    <dd>
                        <span class="a-screen" :key="i" v-for="(list, i) in scoreList"
                            :class="score1 == list.id ? 'a-screen current' : 'a-screen'"
                            @click="fillter(list.id,'score1')">{{ list.name }}</span>
                    </dd>
                </dl>
                <dl class="opport-screen bdbe">
                    <dt class="fl">投资力度</dt>
                    <dd>
                        <span class="a-screen" :key="i" v-for="(list, i) in scoreList"
                            :class="score2 == list.id ? 'a-screen current' : 'a-screen'"
                            @click="fillter( list.id,'score2')">{{ list.name }}</span>
                    </dd>
                </dl>
                <dl class="opport-screen bdbe">
                    <dt class="fl">本省关联度</dt>
                    <dd>
                        <span class="a-screen" :key="i" v-for="(list, i) in scoreList"
                            :class="score3 == list.id ? 'a-screen current' : 'a-screen'"
                            @click="fillter( list.id,'score3')">{{ list.name }}</span>
                    </dd>
                </dl>
                <dl class="opport-screen bdbe">
                    <dt class="fl">战略态势</dt>
                    <dd class="fl">
                        <span :class="strategy == '' ? 'a-screen current' : 'a-screen'"
                            @click="fillter('', 'strategy')">全部</span>
                        <span v-for="(list, i) in strategyList" :key="i" @click="fillter(list.type, 'strategy')"
                            :class="strategy == list.type ? 'a-screen current' : 'a-screen'">{{ list.name
                            }}</span>
                    </dd>
                </dl>
                <dl class="opport-screen bdbe">
                    <dt class="fl">选址逻辑</dt>
                    <dd class="fl">
                        <span :class="site == '' ? 'a-screen current' : 'a-screen'"
                            @click="fillter('', 'site')">全部</span>
                        <span v-for="(list, i) in siteList" :key="i" @click="fillter(list.type, 'site')"
                            :class="site == list.type ? 'a-screen current' : 'a-screen'">{{ list.name
                            }}</span>
                    </dd>
                </dl>
                <dl class="opport-screen bdbe">
                    <dt class="fl">经营信息</dt>
                    <dd class="fl">
                        <span :class="operate == '' ? 'a-screen current' : 'a-screen'"
                            @click="fillter('', 'operate')">全部</span>
                        <span v-for="(list, i) in operateList" :key="i" @click="fillter(list.type, 'operate')"
                            :class="operate == list.type ? 'a-screen current' : 'a-screen'">{{ list.name
                            }}</span>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
                userdata: {},
                score1: 0,
				score2: 0,
				score3: 0,
				scoreList: [{ name: '全部', id: 0 }, { name: "A级", id: 1 }, { name: "B级", id: 2 }, { name: "C级", id: 3 }],
				strategyList: [
                { name: '扩张期', type: 1 },
                { name: '稳定期', type: 2 },
                { name: '收缩期', type: 3 },
                { name: '转型期', type: 4 },
                { name: '扩张放缓期', type: 5 }
            ],
            strategy: '',
            siteList: [
                { name: '资源-原料导向', type: 1 },
                { name: '要素成本导向', type: 2 },
                { name: '产业集群导向', type: 3 },
                { name: '市场-客户导向', type: 4 },
                { name: '特殊区位-政策导向', type: 5 },
                { name: '风险规避-供应链韧性导向', type: 6 }
            ],
            site: '',
            operateList: [
                { name: '经营稳健', type: 1 },
                { name: '增长停滞', type: 2 },
                { name: '业绩下滑', type: 3 },
            ],
            operate: '',
			primaryElectionId:1,
        }
    },
    mounted() {
        this.userdata = this.getuseriformation();
    },
    methods: {
        selectedPrimaryElectionId(id){
			this.primaryElectionId = id;
            if(id == 1){
                this.score1 = 0;
                this.score2 = 0;
                this.score3 = 0;
                this.strategy = '';
                this.site = '';
                this.operate = '';
                this.$emit('chooseOption', this.strategy, this.site, this.operate, this.score1, this.score2, this.score3);
            }else{
                // this.notionCode = 0;
                // this.province = 0;
                // this.cityid = 0;
                // this.countyid = 0;
            }
			
			// this.ajaxsearchcompany(1);
		},
		fillter(value, type) {
            if(!this.userdata.token){
						this.isShowFreeUserTips = true;
						return;
					} 
            switch (type) {
                case 'strategy':
                    this.strategy = value;
                    break;
                case 'site':
                    this.site = value;
                    break;
                case 'operate':
                    this.operate = value;
                    break;
                case 'score1':
                    this.score1 = value;
                    break;
                case 'score2':
                    this.score2 = value;
                    break;
                case 'score3':
                    this.score3 = value;
                    break;
            }
            this.$emit('chooseOption', this.strategy, this.site, this.operate, this.score1, this.score2, this.score3);
        },
    },
}
</script>

<style lang="scss" scoped>
.map_title_tab.second_tab{
	.title.current{
		color: #2170c0 !important;
		border-bottom: 2px solid #2170c0 !important;
	}
}
.map_title_tab.second_tab{
	.title{
		&:hover{
			color: #2170c0 !important;
	        border-bottom: 2px solid #2170c0 !important;
		}
	}
}
</style>